import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StoreStep } from '@upstart/harmony/lib/constants';
import DataTable from './DataTable';
import QuickStats from './QuickStats';
import SearchForm from './SearchForm';
import LoadingOverlay from '../LoadingOverlay';
import ResultsWrapper from './ResultsWrapper';
import { getSalesPersonTable, getCSVFileName } from './config';

function ResultsStore({ query, analytics, dealer }) {
  const [salespersonName, setSalespersonName] = useState('');
  const { data } = analytics;

  /**
   * Filter statistics entries by salesperson name if provided
   */
  function filterStatistics(statistics) {
    return (
      !salespersonName ||
      statistics.name.toLowerCase().includes(salespersonName.toLowerCase())
    );
  }

  /**
   * Adds any statistics derived from other statistics, this needed to properly export a csv
   */
  function addDerivedStatistics(statistics) {
    return {
      ...statistics,
      manualTestDrive: Math.max(
        0,
        statistics[StoreStep.testDrive] -
          statistics[StoreStep.automaticTestDrive],
      ),
    };
  }

  const quickStats = [
    {
      label: 'In-Store deals',
      value: data?.totalCount,
      tooltip:
        'The aggregated result of all Deals created through Upstart Instore.',
    },
    {
      label: 'Test Drives',
      value: data?.testDriveCount,
      tooltip: 'The total number of test drives completed.',
    },
    {
      label: 'Credit Applications',
      value: data?.creditAppCount,
      tooltip:
        'The total number of credit applications completed through the Upstart Instore.',
    },
    {
      label: 'Sold Vehicles',
      value: data?.soldCount,
      tooltip:
        'The total number of vehicles marked as sold through Upstart Instore.',
    },
  ];

  if (dealer?.insurance?.instore?.enabled) {
    quickStats.push({
      label: 'Insurance Applications',
      value:
        data?.userStatistics?.reduce((sum, stat) => sum + stat.insurance, 0) ||
        0,
      tooltip:
        'The total number of insurance requests submitted through Upstart.',
    });
  }

  return (
    <LoadingOverlay active={analytics.fetching}>
      {data && (
        <div>
          <QuickStats stats={quickStats} />
          <div className="row">
            <div className="col-xs-12">
              <div className="data-table-label">
                Completed Steps by Salesperson
              </div>
              <SearchForm
                placeholder="Salesperson Name"
                onSubmit={setSalespersonName}
              />
              <DataTable
                data={data.userStatistics
                  .filter(filterStatistics)
                  .map(addDerivedStatistics)}
                config={getSalesPersonTable(dealer)}
                exportCSV
                csvFileName={getCSVFileName(
                  'ProdigyInStoreResults',
                  dealer,
                  query,
                )}
              />
            </div>
          </div>
        </div>
      )}
    </LoadingOverlay>
  );
}

ResultsStore.propTypes = {
  query: PropTypes.object.isRequired,
  analytics: PropTypes.object.isRequired,
  dealer: PropTypes.object.isRequired,
};

export default ResultsWrapper(ResultsStore);
